module.exports = __webpack_public_path__ + "static/media/puzzle-society.09eecea3.png";